import * as stylex from '@stylexjs/stylex';
import { useTranslation } from 'react-i18next';
import { faClose } from '@seeqdev/icons/fa-sharp-regular-svg-icons';
import { Icon } from '@seeqdev/qomponents';
import { colors } from '@seeqdev/qomponents/colors.stylex';

interface SearchResultRemovableProps {
  itemId: string;
  itemIcon: React.ReactNode;
  itemName: string;
  itemAncestors?: string;
  onRemove: (itemId: string) => void;
}

export const SearchResultRemovable = ({
  itemId,
  itemIcon,
  itemName,
  itemAncestors,
  onRemove,
}: SearchResultRemovableProps) => {
  const { t } = useTranslation();

  return (
    <div
      key={`key_${itemId}`}
      {...stylex.props(searchResultRemovableStyles.result)}
      className={`flexRowContainer flexFill ${stylex.props(searchResultRemovableStyles.result).className}`}>
      <div
        {...stylex.props(searchResultRemovableStyles.content)}
        className={`flexColumnContainer flexFill ${stylex.props(searchResultRemovableStyles.content).className}`}>
        {itemIcon}
        <div
          {...stylex.props(searchResultRemovableStyles.name)}
          className={`searchResultName flexFill ${stylex.props(searchResultRemovableStyles.name).className}`}>
          <span {...stylex.props(searchResultRemovableStyles.nameText)}>{itemName}</span>
          {itemAncestors && <span {...stylex.props(searchResultRemovableStyles.ancestors)}>{itemAncestors}</span>}
        </div>
        <Icon
          icon={faClose}
          type="text"
          onClick={() => onRemove(itemId)}
          testId="removeSearchResult"
          tooltip={t('SEARCH_DATA.REMOVABLE_RESULT_TOOLTIP')}
          xstyle={searchResultRemovableStyles.removeIcon}
        />
      </div>
    </div>
  );
};

export const searchResultRemovableStyles = stylex.create({
  result: {
    display: 'flex',
    flexDirection: 'column',
    flex: '1 1 auto',
    overflow: 'hidden',
    borderWidth: '0.0625rem',
    borderStyle: 'solid',
    borderColor: colors.selectedSearchItemBorder,
    borderRadius: '0.3125rem',
    margin: '0.125rem',
    padding: '0.125rem 0.1875rem',
    minHeight: '1.875rem',
  },
  content: {
    display: 'flex',
    flexDirection: 'row',
    flex: '1 1 auto',
    overflow: 'hidden',
    alignItems: 'center',
    justifyContent: 'center',
  },
  name: { flex: '1 1 auto', overflow: 'hidden' },
  nameText: { overflowWrap: 'break-word', whiteSpace: 'normal' },
  ancestors: {
    lineHeight: '90%',
    fontSize: '75%',
    color: colors.mutedForeground,
    overflowWrap: 'break-word',
    whiteSpace: 'normal',
    marginLeft: '0.3125rem',
    paddingBottom: '0.125rem',
    fontStyle: 'italic',
  },
  removeIcon: { marginRight: 10, cursor: 'pointer' },
});
